module.exports = __webpack_public_path__ + "pc/img/swiper_logo_01.2c027745.png";